import _ from 'underscore'
import axios from 'axios'
import moment from 'moment'

import { log } from '@/services/logService.js'

const API = process.env.BASE_URL

const statuses = {
  unknown: { id: 0, name: 'unknown' },
  cancelled: { id: 1, name: 'cancelled', label: 'Dostava otkazana', icon: 'fa-times-circle' },
  open: { id: 2, name: 'open', label: 'Dostava za prijavu', icon: 'fa-file-alt' },
  openLate: { id: 3, name: 'openLate', label: 'Dostava za prijavu - nema prijava', icon: 'fa-exclamation-triangle' },
  accepted: { id: 4, name: 'accepted', label: 'Kurir dolazi', icon: 'fa-user-check' },
  lateToPickup: { id: 5, name: 'lateToPickup', label: 'Kurir kasni na preuzimanje', icon: 'fa-exclamation-triangle' },
  transit: { id: 6, name: 'transit', label: 'Dostava u toku', icon: 'fa-truck' },
  lateToDeliver: { id: 7, name: 'lateToDeliver', label: 'Kurir kasni na uručenje', icon: 'fa-exclamation-triangle' },
  delivered: { id: 8, name: 'delivered', label: 'Dostava izvršena', icon: 'fa-check-circle' }
}

let deliveries = []
let comments = {}

// update delivery in local memory structure
function updateDelivery (newDelivery, date) {
  newDelivery.lastUpdated = date
  let oldDelivery = _.findWhere(deliveries, { id: +newDelivery.id })
  if (oldDelivery) {
    _.extend(oldDelivery, newDelivery)
    return oldDelivery
  } else {
    insertSorted(deliveries, newDelivery, newerFirst)
    nextEvent(newDelivery)
    newDelivery.updateHandle = setInterval(nextEvent, 15000, newDelivery)
    return newDelivery
  }
}
function insertSorted (array, element, comparator) {
  for (var i = 0; i < array.length && comparator(array[i], element); i++) {}
  array.splice(i, 0, element)
}

function newerFirst (a, b) { return a.id > b.id }

function nextEvent (delivery) {
  if (!delivery.time_picked_up) {
    // console.log('nextEvent', delivery.time_targeted_pickup)
    delivery.nextEvent = 'Preuzimanje dostave ' + (delivery.time_targeted_pickup ? moment(delivery.time_targeted_pickup).fromNow() : 'što pre')
  } else if (!delivery.time_delivered) {
    delivery.nextEvent = 'Dostava ' + (delivery.time_targeted_delivery ? moment(delivery.time_targeted_delivery).fromNow() : 'što pre')
  } else {
    clearInterval(delivery.updateHandle)
    delivery.nextEvent = ''
  }
}

function getDeliveryStatus (delivery) {
  if (!delivery) {
    return statuses.unknown
  } else if (delivery.cancelled) {
    return statuses.cancelled
  } else if (delivery.time_delivered) {
    return statuses.delivered
  } else if (delivery.time_picked_up) {
    let target = delivery.time_targeted_delivery ? moment(delivery.time_targeted_delivery) : moment(delivery.time_created).add(20, 'minutes')
    if (target.isBefore()) {
      return statuses.lateToDeliver
    } else {
      return statuses.transit
    }
  } else if (delivery.time_accepted) {
    let target = delivery.time_targeted_pickup ? moment(delivery.time_targeted_pickup) : moment(delivery.time_created).add(10, 'minutes')
    if (target.isBefore()) {
      return statuses.lateToPickup
    } else {
      return statuses.accepted
    }
  } else if (delivery.time_created) {
    let target = delivery.time_targeted_pickup ? moment(delivery.time_targeted_pickup) : moment(delivery.time_created).add(10, 'minutes')
    if (target.isBefore()) {
      return statuses.openLate
    } else {
      return statuses.open
    }
  } else {
    return statuses.unknown
  }
}

const counter = {
  newDeliveries: 0
}
function refreshNewDeliveriesIndicator () {
  let newDeliveriesCount = 0
  for (const delivery of deliveries) {
    if (getDeliveryStatus(delivery).name === 'open') {
      newDeliveriesCount++
    }
  }
  counter.newDeliveries = newDeliveriesCount
}

export default {
  getDeliveryStatus,
  getDeliveries: function (oldestId) {
    this.getDeliveriesPromise(oldestId)
    return deliveries
  },
  getDeliveriesPromise: function (oldestId) {
    return axios.get(`${API}/deliveries`, { headers: { 'older-than-id': oldestId } }).then(response => {
      // deliveries.length = 0
      // deliveries.push(...response.data.deliveries)
      let date = new Date()
      _.each(response.data.deliveries, delivery => updateDelivery(delivery, date))
      refreshNewDeliveriesIndicator()
      return response.data.deliveries
    })
  },
  getDelivery: function (deliveryId) {
    return axios.get(`${API}/deliveries/${deliveryId}`).then(response => {
      const delivery = updateDelivery(response.data, new Date())
      refreshNewDeliveriesIndicator()
      return delivery
    }, error => {
      log(`getDelivery error ${error}`)
      return null
    })
  },
  getDeliveryComments: function (deliveryId) {
    if (!comments[deliveryId]) {
      comments[deliveryId] = []
    }
    axios.get(`${API}/deliveries/${deliveryId}/comments`).then(response => {
      comments[deliveryId].length = 0
      comments[deliveryId].push(...response.data.comments)
    })
    return comments[deliveryId]
  },
  postDelivery: function (delivery) {
    return axios.post(`${API}/deliveries`, delivery).then(response => {
      return response.data
    })
  },
  postDeliveryComment: function (deliveryId, deliveryComment) {
    return axios.post(`${API}/deliveries/${deliveryId}/comments`, { deliveryComment }).then(response => {
      return response.data
    })
  },
  applyForDelivery: function (delivery) {
    return axios.post(`${API}/deliveries/${delivery.id}/apply`).then(response => {
      return response.data
    })
  },
  assignDelivery: function (delivery, courier) {
    return axios.post(`${API}/deliveries/${delivery.id}/assign/${courier.id}`).then(response => {
      return response.data
    })
  },
  pickupDelivery: function (delivery) {
    return axios.post(`${API}/deliveries/${delivery.id}/pickup`).then(response => {
      return response.data
    })
  },
  finishDelivery: function (delivery) {
    return axios.post(`${API}/deliveries/${delivery.id}/finish`).then(response => {
      return response.data
    })
  },
  cancelDelivery: function (delivery, reason) {
    return axios.post(`${API}/deliveries/${delivery.id}/cancel`, { reason }).then(response => {
      return response.data
    })
  },
  counter: function () {
    return counter
  }
}
